module.exports = __webpack_public_path__ + "img/FR18707.7cf69015.png";